// extracted by mini-css-extract-plugin
export default {"facetMenu":"Gu-z","fixed":"Hu-z","nonLayerdFacets":"Iu-z","productCount":"Ju-z","facetBack":"Ku-z","arrow":"Lu-z","facetClose":"Mu-z"};